import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SharedUploaderJobSeekerResumesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SharedUploaderJobSeekerResumesQuery = { __typename?: 'Query', jobSeekerResumes?: { __typename?: 'JobSeekerResumesPayload', resumes: Array<{ __typename?: 'JobSeekerResumeBundle', resumeId: string, resume?: { __typename?: 'JobSeekerProfileResume', resumeType?: Types.JobSeekerProfileResumeType | null } | null }> } | null };

export type SharedUploaderDeleteResumeBundleMutationVariables = Types.Exact<{
  input: Types.DeleteResumeBundleInput;
}>;


export type SharedUploaderDeleteResumeBundleMutation = { __typename?: 'Mutation', deleteResumeBundle?: { __typename?: 'DeleteResumeBundlePayload', resumeId: string } | null };


export const SharedUploaderJobSeekerResumesDocument = gql`
    query SharedUploaderJobSeekerResumes {
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        resumeType
      }
    }
  }
}
    `;

/**
 * __useSharedUploaderJobSeekerResumesQuery__
 *
 * To run a query within a React component, call `useSharedUploaderJobSeekerResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedUploaderJobSeekerResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedUploaderJobSeekerResumesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharedUploaderJobSeekerResumesQuery(baseOptions?: Apollo.QueryHookOptions<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>(SharedUploaderJobSeekerResumesDocument, options);
      }
export function useSharedUploaderJobSeekerResumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>(SharedUploaderJobSeekerResumesDocument, options);
        }
export function useSharedUploaderJobSeekerResumesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>(SharedUploaderJobSeekerResumesDocument, options);
        }
export type SharedUploaderJobSeekerResumesQueryHookResult = ReturnType<typeof useSharedUploaderJobSeekerResumesQuery>;
export type SharedUploaderJobSeekerResumesLazyQueryHookResult = ReturnType<typeof useSharedUploaderJobSeekerResumesLazyQuery>;
export type SharedUploaderJobSeekerResumesSuspenseQueryHookResult = ReturnType<typeof useSharedUploaderJobSeekerResumesSuspenseQuery>;
export type SharedUploaderJobSeekerResumesQueryResult = Apollo.QueryResult<SharedUploaderJobSeekerResumesQuery, SharedUploaderJobSeekerResumesQueryVariables>;
export const SharedUploaderDeleteResumeBundleDocument = gql`
    mutation SharedUploaderDeleteResumeBundle($input: DeleteResumeBundleInput!) {
  deleteResumeBundle(input: $input) {
    resumeId
  }
}
    `;
export type SharedUploaderDeleteResumeBundleMutationFn = Apollo.MutationFunction<SharedUploaderDeleteResumeBundleMutation, SharedUploaderDeleteResumeBundleMutationVariables>;

/**
 * __useSharedUploaderDeleteResumeBundleMutation__
 *
 * To run a mutation, you first call `useSharedUploaderDeleteResumeBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharedUploaderDeleteResumeBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharedUploaderDeleteResumeBundleMutation, { data, loading, error }] = useSharedUploaderDeleteResumeBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharedUploaderDeleteResumeBundleMutation(baseOptions?: Apollo.MutationHookOptions<SharedUploaderDeleteResumeBundleMutation, SharedUploaderDeleteResumeBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharedUploaderDeleteResumeBundleMutation, SharedUploaderDeleteResumeBundleMutationVariables>(SharedUploaderDeleteResumeBundleDocument, options);
      }
export type SharedUploaderDeleteResumeBundleMutationHookResult = ReturnType<typeof useSharedUploaderDeleteResumeBundleMutation>;
export type SharedUploaderDeleteResumeBundleMutationResult = Apollo.MutationResult<SharedUploaderDeleteResumeBundleMutation>;
export type SharedUploaderDeleteResumeBundleMutationOptions = Apollo.BaseMutationOptions<SharedUploaderDeleteResumeBundleMutation, SharedUploaderDeleteResumeBundleMutationVariables>;